import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import { actionCreators } from '../../store/WorkOrder';
import Pagination from '../Pagination';
import Breadcrumb from '../BreadcrumbMenu';
import Search from "../Search";

class WorkOrderList extends Component{
  
  constructor(props) {
    super(props);
    
    this.handleClick = this.handleClick.bind(this);
    this.searchLoadAll = this.searchLoadAll.bind(this);
  }
  
  componentDidMount(){
    if (this.props.workorders.display.length === 0){
      this.props.requestWorkOrders();
    }
  }
  
  componentWillUnmount() {
    if (this.props.workorders.query.workOrderType){
      this.props.clearState();
    }  
  }
  

  handleClick(event){
    let id = event.currentTarget.getAttribute("id");
    this.props.history.push("/services/" + id);
  }
  
  searchLoadAll(event){
    this.props.clearStatePreserveSearch();
    this.props.requestWorkOrders();
  }
  
    render() {
    return(
      <div>
        <Breadcrumb/>
        
        <div className="container-header">
          <div className="header-start">
            <h3>Services</h3>
          </div>
          <div className="header-end">
            <Search setSearch={this.props.setSearch} search={this.props.search} requestRecords={this.props.requestWorkOrders} clearState={this.props.clearState}/>
          </div>
        </div>
   
        <div className="centered-container border">
          <div className="container-body">
            <table className="cdb-table">
              <tbody>
              <tr>
                <th>PO #</th>
                <th>Service #</th>
                <th>Type</th>
                <th>Service</th>
                <th>Status</th>
                <th>Location</th>
                <th>City/State</th>
                <th>Sched. Date</th>
                <th>GPS</th>
              </tr>
              {this.props.workorders.display.map((wo) => {
                return(
                  <tr key={wo.id} onClick={this.handleClick} id={wo.workOrderNumber}>
                    <td>{wo.customerPO}</td>
                    <td>{wo.workOrderNumber}</td>
                    <td>{wo.workOrderType}</td>
                    <td>{wo.serviceType}</td>
                    <td>{wo.status}</td>
                    <td>{wo.storeName}</td>
                    <td>{wo.city}, {wo.state}</td>
                    <td>{wo.scheduled}</td>
                    <td>
                      {wo.isGPS? <span className="icon-gps-checked-in"/> : <span className=""/>}
                    </td>
                  </tr>
                );
              })}
              </tbody>
            </table>
          </div>
        </div>
        
        {this.props.search !== '' && !this.props.paginate ?
          <div style={{display: 'flex', justifyContent: 'center'}}>
              <button className="btn-primary btn-lg" onClick={this.searchLoadAll}
                      style={{width: '200px'}}>Load All Results
              </button>
          </div>
          : ''
        }
        
        {this.props.paginate ?
          <Pagination paginateFunc={this.props.requestWorkOrders} currentPage={this.props.currentPage}
                      pageCount={this.props.pageCount}/>
          : ''
        }
      </div>
    );
  }
}

WorkOrderList.propTypes = {
  workorders: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  requestWorkOrders: PropTypes.func.isRequired,
  search: PropTypes.string,
  setSearch: PropTypes.func.isRequired,
  clearState: PropTypes.func.isRequired,
  clearStatePreserveSearch: PropTypes.func.isRequired,
  paginate: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    currentPage: state.workorders.page,
    pageCount: state.workorders.pageCount,
    workorders: state.workorders,
    search: state.workorders.search,
    paginate: state.workorders.paginate
  }
}

export default connect(mapStateToProps, 
    dispatch => bindActionCreators(actionCreators, dispatch))(WorkOrderList);